module.exports = "//static.hsappstatic.net/salesImages/static-1.403/email-images/check@2x.png"